module.exports = __webpack_public_path__ + "static/img/cervicalPain_0.55676784.png";